import UserSettingsIcon from './component'

export default UserSettingsIcon
